import {
  Card,
  CardBody,
  CardHeader,
  CardProps,
  Heading,
} from '@chakra-ui/react'

import { CardMessage } from '../../components/CardMessage/CardMessage'
import { createWidget } from '../widget-utils'

export type CardWidgetProps = CardProps & {
  title?: string
  /**
   * Whether or not to fill the content of the card with the children.
   * Removing content padding.
   */
  fillContent?: boolean
  /** Overrides theme `CardBody` padding when set (e.g. one-off CMS layouts). */
  bodyPadding?: string
  noDataText?: string
  itemList?: unknown[] | null
  isLoading?: boolean
}

export const CardWidget = ({
  title,
  fillContent,
  bodyPadding,
  children,
  noDataText,
  itemList,
  isLoading,
  ...props
}: CardWidgetProps) => {
  // Note: may need to figure out how padding should work here.

  return (
    <Card
      variant={itemList?.length === 0 ? 'disabled' : 'default'}
      display="flex"
      flexDirection="column"
      {...props}
    >
      {title && (
        <CardHeader>
          <Heading
            fontWeight="700"
            fontSize="14px"
            color="presets.turquoise.100"
            fontFamily="Montserrat"
          >
            {title}
          </Heading>
        </CardHeader>
      )}
      <CardBody p={fillContent ? '0' : (bodyPadding ?? undefined)} flex="1">
        {itemList?.length! === 0 ? (
          <CardMessage message={noDataText} />
        ) : (
          children
        )}
      </CardBody>
    </Card>
  )
}

export const CardWidgetDefinition = createWidget(CardWidget, {
  type: 'Card',
})
